import { DateFactory } from 'rhg-vue-common'

export default class IntervalTimeLabel {
  static fromJSON (json) {
    return new IntervalTimeLabel({
      startDate: json.startDate,
      endDate: json.endDate
    })
  }

  constructor ({ text, startDate, endDate }) {
    this.startDate = startDate || null
    this.endDate = endDate || null
  }

  toBeShown () {
    if (this.endDate === '' || this.endDate === null) {
      this.endDate = DateFactory.addMonths(this.startDate, 3)
    } else {
      this.endDate = new Date(this.endDate)
    }

    var todayDate = new Date()
    this.startDate = new Date(this.startDate)

    return (!isNaN(this.startDate) && !isNaN(this.endDate) && todayDate.getTime() >= this.startDate.getTime() && todayDate.getTime() <= this.endDate.getTime())
  }
}
